import React, { useState } from "react";
import {
    Box,
    Chip,
    Collapse,
    IconButton,
    Link,
    TableCell,
    TableRow,
    Tooltip,
    Typography
} from "@mui/material";
import dayjs from "dayjs";
import CircleIcon from "@mui/icons-material/Circle";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import RedeemIcon from "@mui/icons-material/Redeem";
import SecurityIcon from "@mui/icons-material/Security";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import StarsIcon from "@mui/icons-material/Stars";
import LogoutIcon from "@mui/icons-material/Logout";
import BlockIcon from "@mui/icons-material/Block";

const hasActivePerms = (player) => Array.isArray(player.timed_perms) && player.timed_perms.length > 0;

const PlayerRow = ({ player, onOpenModal }) => {
    const [open, setOpen] = useState(false);
    const active = dayjs().diff(dayjs(player.updated_at), "minute") <= 15;
    const vip = hasActivePerms(player);

    return (
        <>
            <TableRow hover>
                <TableCell width={40}>
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Link href={`https://steamcommunity.com/profiles/${player.steam_id}`} target="_blank">
                        {player.steam_id}
                    </Link>
                </TableCell>
                <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                        {active && <CircleIcon sx={{ fontSize: 10, color: "green" }} />}
                        {vip && (
                            <Tooltip title="Есть активные привилегии">
                                <StarsIcon sx={{ fontSize: 16, color: "#b8a26e" }} />
                            </Tooltip>
                        )}
                        {player.name}
                    </Box>
                </TableCell>
                <TableCell>{player.game_times}</TableCell>
                <TableCell>{player.updated_at}</TableCell>
                <TableCell align="right">
                    <Box display="flex" justifyContent="flex-end" gap={0.5}>
                        <Tooltip title="Выдать VIP">
                            <IconButton size="small" onClick={() => onOpenModal("vip", player)}>
                                <EmojiEventsIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {player.auth_name ? (
                            <Tooltip title="Изменить баланс / бонусы">
                                <IconButton size="small" onClick={() => onOpenModal("balance", player)}>
                                    <MonetizationOnIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                        <Tooltip title="Кикнуть">
                            <IconButton size="small" onClick={() => onOpenModal("kick", player)}>
                                <LogoutIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Забанить">
                            <IconButton size="small" color="error" onClick={() => onOpenModal("ban", player)}>
                                <BlockIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={6} sx={{ p: 0 }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ p: 2, bgcolor: "background.default" }}>
                            <Box display="flex" gap={4} flexWrap="wrap">
                                <Box>
                                    <Typography variant="caption">Первая игра</Typography>
                                    <Typography>{player.created_at}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption">Баланс</Typography>
                                    <Box display="flex" alignItems="center" gap={0.5}>
                                        <MonetizationOnIcon fontSize="small" color="action" />
                                        <Typography>{player.balance}</Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography variant="caption">Бонусы</Typography>
                                    <Box display="flex" alignItems="center" gap={0.5}>
                                        <RedeemIcon fontSize="small" color="action" />
                                        <Typography>{player.bonuses}</Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography variant="caption">Аккаунт сайта</Typography>
                                    <Box display="flex" alignItems="center" gap={0.5}>
                                        <SecurityIcon fontSize="small" color="action" />
                                        <Typography>{player.auth_name ? `${player.auth_name} (${player.auth_id})` : "не привязан"}</Typography>
                                    </Box>
                                </Box>
                                {vip && (
                                    <Box>
                                        <Typography variant="caption">Привилегии</Typography>
                                        <Box display="flex" gap={1} mt={0.5}>
                                            {player.timed_perms.map((perm, i) => (
                                                <Chip
                                                    key={i}
                                                    icon={<EmojiEventsIcon sx={{ color: "#b8a26e" }} />}
                                                    label={`${perm.type.toUpperCase()} до ${perm.valid_until}`}
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{ borderColor: "#b8a26e", color: "#b8a26e", "& .MuiChip-icon": { marginLeft: "4px" } }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default PlayerRow;
